import { makeStyles } from '@material-ui/core/styles'
import { Form as FinalForm } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import { Typography, IconButton, Grid } from '@material-ui/core'
import Button from '../../../control/button/button'

import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { FC, useState } from 'react'
import { Form as FormT } from '../../../services/um/useRegisterExternal'

import useTranslate from '../../../i18n/useTranslate'
import arrayMutators from 'final-form-arrays'
import UploadDocFile from '../../web/shareUI/uploadDoc/UploadDocFile'
import { ValidationErrors } from 'final-form'
import { textRequired, validateEmail } from '../../../utilities/validate'

import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import { spellWord } from '../../../utilities/email'

import isEmail from 'validator/lib/isEmail'

interface FormProps {
    onClickSubmit: (values: FormT) => void
    onClickDisplayPW: () => void
    onClickDisplayCfPW: () => void
    onChangeMobilePhone: (value: string, fnCallback: (valBack: string) => void) => void
    onClickBackLink: () => void
    onClickCheck: (value: string) => void
    onChangeUsername: () => void
    displayPW: boolean
    displayCfPW: boolean
    canUse: 'pass' | 'failed' | undefined
}
const Form: FC<FormProps> = ({
    onClickSubmit,
    onClickDisplayPW,
    onClickDisplayCfPW,
    onChangeMobilePhone,
    onClickBackLink,
    onClickCheck,
    onChangeUsername,
    displayPW,
    displayCfPW,
    canUse,
}) => {
    const classes = useStyles()
    const translate = useTranslate()

    const [fileInitial] = useState([
        {
            uploadFileObj: {
                fileList: [],
                subTopicPageList: [],
                documentTopicID: 99,
            },
        },
    ])
    const topicInitial = [
        {
            id: 99,
            no: '',
            name_th: 'โครงการวิจัยและเอกสารที่เกี่ยวข้อง',
            name_en: 'Research projects and related documents',
            code: '',
            subtopic: [],
        },
    ]

    const validateForm = (values: FormT) => {
        const errors: ValidationErrors = {}

        if (values.password && values.confirmPassword) {
            if (values.confirmPassword !== values.password) {
                errors.confirmPassword = translate.get('MESSAGE.M019')
            }
        }

        if (values.email && !isEmail(values.email)) {
            errors.email = translate.get('MESSAGE.M017')
        }

        return errors
    }

    const Icon = () => {
        switch (canUse) {
            case 'pass':
                return <CheckCircleIcon style={{ color: 'green' }} />
            case 'failed':
                return <CancelIcon style={{ color: 'red' }} />

            default:
                return <></>
        }
    }

    const onChkEmail = (val: string) => {
        let error = false
        if (val && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val)) {
            error = true
        }

        return error
    }

    return (
        <FinalForm
            onSubmit={onClickSubmit}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={{ uploadFile: fileInitial }}
            validate={validateForm}
        >
            {({ handleSubmit, form, values }) => {
                return (
                    <Grid container spacing={2} className={classes.root}>
                        <Grid item xs={12}>
                            <Typography variant="h6" className={classes.typo}>
                                {translate.get('UM.EXTERNAL-REGISTER.ACCOUNT')}
                            </Typography>
                            <Typography style={{ color: 'red' }}>
                                {translate.get('UM.EXTERNAL-REGISTER.TITLE_DES')}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <MyTextfield
                                name="email"
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-REGISTER.EMAIL'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-REGISTER.EMAIL'),
                                    size: 'medium',
                                }}
                                icon={<Icon />}
                                handleValueChange={(valueEmail) => {
                                    if (!valueEmail) {
                                        onClickCheck(valueEmail)
                                    } else {
                                        const result = spellWord(valueEmail)
                                        form.change('email', result)
                                        onChangeUsername()
                                    }
                                }}
                                error={onChkEmail(values.email)}
                                required
                                validates={[validateEmail(translate.get('MESSAGE.M017'))]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} className={classes.buttonCheck}>
                            <Button
                                size={'large'}
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={() => onClickCheck(values.email)}
                                style={{ height: '50px', bottom: onChkEmail(values.email) ? '17px' : '0px' }}
                            >
                                {translate.get('UM.EXTERNAL-REGISTER.CHECK')}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MyTextfield
                                name="password"
                                type={displayPW ? 'text' : 'password'}
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-REGISTER.PASSWORD'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-REGISTER.PASSWORD'),
                                    size: 'medium',
                                }}
                                icon={
                                    <IconButton size="small" onClick={onClickDisplayPW}>
                                        {displayPW ? (
                                            <Visibility style={{ fontSize: '1.2rem' }} />
                                        ) : (
                                            <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                        )}
                                    </IconButton>
                                }
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MyTextfield
                                name="confirmPassword"
                                type={displayCfPW ? 'text' : 'password'}
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-REGISTER.CONFIRM-PASSWORD'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-REGISTER.CONFIRM-PASSWORD'),
                                    size: 'medium',
                                }}
                                icon={
                                    <IconButton size="small" onClick={onClickDisplayCfPW}>
                                        {displayCfPW ? (
                                            <Visibility style={{ fontSize: '1.2rem' }} />
                                        ) : (
                                            <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                        )}
                                    </IconButton>
                                }
                                required
                                validates={[textRequired('test')]}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6" className={classes.typo}>
                                {translate.get('UM.EXTERNAL-REGISTER.PROFILE')}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MyTextfield
                                name="nameTH"
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-REGISTER.NAME-TH'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-REGISTER.NAME-TH'),
                                    size: 'medium',
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MyTextfield
                                name="nameEN"
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-REGISTER.NAME-EN'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-REGISTER.NAME-EN'),
                                    size: 'medium',
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="telephone"
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-REGISTER.TELEPHONE'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-REGISTER.TELEPHONE'),
                                    size: 'medium',
                                }}
                                handleValueChange={(value) =>
                                    onChangeMobilePhone(value, (valBack) => {
                                        form.change('telephone', valBack)
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <MyTextfield
                                name="departments"
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-REGISTER.DEPARTMENT'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-REGISTER.DEPARTMENT'),
                                    size: 'medium',
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <MyTextfield
                                name="departments_en"
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-REGISTER.DEPARTMENT_EN'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-REGISTER.DEPARTMENT_EN'),
                                    size: 'medium',
                                }}
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6" className={classes.typo}>
                                {translate.get('UM.EXTERNAL-REGISTER.CONSIDER')}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="reason"
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-REGISTER.REASON'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-REGISTER.REASON'),
                                    size: 'medium',
                                    rows: 5,
                                    multiline: true,
                                }}
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6" className={classes.typo}>
                                {translate.get('UM.EXTERNAL-REGISTER.UPLOAD')} *
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <UploadDocFile documentTitleList={topicInitial} accept={'.pdf'} />
                        </Grid>

                        <Grid item xs={6} className={classes.rootLink}>
                            <Typography className={classes.link} onClick={onClickBackLink}>
                                {translate.get('UM.EXTERNAL-REGISTER.OTHER-ACCOUNT')}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container justify="flex-end">
                                <Grid item xs={12} sm={8}>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        {translate.get('UM.EXTERNAL-REGISTER.OK')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        </FinalForm>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        padding: '1rem 0px',
    },
    link: {
        color: '#0022FF',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    rootLink: {
        alignSelf: 'center',
    },
    buttonCheck: {
        alignSelf: 'flex-end',
        marginBottom: '10px',
        // paddingTop: '56px ',
        [theme.breakpoints.down('xs')]: {
            // padding: '0px',
        },
    },
    typo: { fontWeight: 'bold', marginBottom: '10px' },
}))

export default Form
